import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { FormOutlined, BarChartOutlined, GlobalOutlined } from '@ant-design/icons';
import { IS_EMBEDDED } from '../config';

const { Sider, Content, Header } = Layout;

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const menuItems = [
    { key: '/', label: <Link to="/">Surveys</Link>, icon: <FormOutlined /> },
    { key: '/stats', label: <Link to="/stats">City Stats</Link>, icon: <BarChartOutlined /> },
    { key: '/create', label: <Link to="/create">Create</Link>, icon: <GlobalOutlined /> },
  ];

  const activeKey = location.pathname.startsWith('/stats')
    ? '/stats'
    : location.pathname.startsWith('/create')
    ? '/create'
    : location.pathname.startsWith('/take') || location.pathname.startsWith('/results')
    ? '/'
    : location.pathname;

  if (IS_EMBEDDED) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: 13, fontWeight: 700 }}>
            City Surveys
          </div>
          <Menu mode="inline" selectedKeys={[activeKey]} items={menuItems} style={{ border: 'none' }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', gap: 24, background: '#fa8c16', padding: '0 24px' }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>City Surveys</span>
      </Header>
      <Layout>
        <Sider width={180} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
          <Menu mode="inline" selectedKeys={[activeKey]} items={menuItems} style={{ border: 'none', paddingTop: 8 }} />
        </Sider>
        <Content style={{ background: '#fafafa' }}>{children}</Content>
      </Layout>
    </Layout>
  );
}
